import React from 'react'
import "./PaymentHistory/PaymentHistory.css";
import { NavLink, Outlet } from 'react-router-dom';
function Account() {
    return (
        <>
            <div className="container mx-auto px-4 mt-4 pt-10 pb-16 md:pb-20 lg:pb-20 xl:pb-20 2xl:pb-20">
                <nav className="flex space-x-10 border-b pb-4 justify-center">
                    <NavLink
                        to="/account"
                        end
                        className={({ isActive }) =>
                            isActive
                                ? "text-blue-500 font-semibold border-b-2 border-blue-500"
                                : "text-blue-500 font-semibold hover:cursor-pointer"
                        }
                    >
                        Current Plan
                    </NavLink>

                    <NavLink
                        to="/account/subscription"
                        className={({ isActive }) =>
                            isActive
                                ? "text-blue-500 font-semibold border-b-2 border-blue-500"
                                : "text-blue-500 font-semibold hover:cursor-pointer"
                        }
                    >
                        Subscription
                    </NavLink>
                </nav>
                <Outlet />
            </div>
        </>
    )
}

export default Account
